<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :ceilingDesignlActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "ceilingdesign",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "ceiling/IMG-20180107-WA0053.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0035.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0047.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0060.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0042.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0037.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20171211-WA0022.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20171211-WA0024.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180107-WA0034.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20171130-WA0082.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20180103-WA0023.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "ceiling/IMG-20171211-WA0015.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Ceiling design and installation",
    serviceDescription:
      "Kitchen units, wooden counters, granite counters and wardrooms design and fitting."
  })
};
</script>
